import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { Benefits, Client, VenueDetail } from '@monorepo-channels/channels/domain'
import { trigger, transition, style, animate } from '@angular/animations'

@Component({
	standalone: true,
	imports: [CommonModule, MatIconModule, MatButtonModule],
	selector: 'ui-porto-bank-order-success',
	templateUrl: './order-success.component.html',
	styleUrls: ['./order-success.component.scss'],
	animations: [
		trigger('fadeInOut', [
			transition(':enter', [style({ opacity: 0 }), animate('200ms', style({ opacity: 1 }))]),
			transition(':leave', [animate('200ms', style({ opacity: 0 }))]),
		]),
	],
})
export class OrderSuccessComponent implements OnInit {
	@Input({ required: true }) type!: 'checkin' | 'reservation'
	@Input({ required: true }) partySize!: number
	@Input({ required: true }) orderDate!: Date | string
	@Input({ required: false }) sectionLabel?: string //Check-In doen't have sectionLabel
	@Input({ required: true }) reservationTime!: string
	@Input({ required: true }) venue!: VenueDetail
	@Input({ required: true }) client!: Client
	@Input({ required: false }) voucherValue!: string | null
	@Input({ required: false }) benefit?: Benefits[]
	@Output() ok = new EventEmitter<void>()

	ngOnInit(): void {
		this.orderDate =
			typeof this.orderDate === 'string'
				? new Date(`${this.orderDate}T10:00:00Z`)
				: new Date(this.orderDate)
	}
}
